
import { Component, Vue } from 'vue-property-decorator'
import { DriverClient, CompanyClient } from '@/api'
import DriverEditor from './editor.vue'
import CompanyRecharge from './companyRecharge.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'

@Component({
  name: 'DriverList',
  components: {
    DriverEditor,
    CompanyRecharge
  },
  filters: {
    formatAge(birthday:any) {
      const aDate = new Date()
      const thisYear = aDate.getFullYear()
      const bDate = new Date(birthday)
      const brith = bDate.getFullYear()
      const age = (thisYear - brith)
      return age
    },
    formatCompany(company:any) {
      return company ? company.name : '未加入任何车队'
    }
  }
})
export default class extends BaseList {
  private rechargeFormVisible=false
  private companyClient = new CompanyClient()
  private companyList = []
  public constructor() {
    super()
    this.client = new DriverClient()
    this.listQuery = {
      filter: {
        where: {
          name: { like: '' },
          mobile_phone_number: { like: '' },
          companyId: this.$store.state.user.companyId
        },
        fields: {
          id: true,
          companyId: true,
          name: true,
          sex: true,
          plate_number: true,
          nation: true,
          birthday: true,
          home_address: true,
          id_card_number: true,
          id_card_scanning_copy: true,
          mobile_phone_number: true,
          account_balance: true,
          remain_balance: true,
          state: true,
          createdAt: true
        },
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt desc'],
        include: [{ relation: 'company' }]
      }
    }
  }

  async created() {
    super.created()
    await this.getCompanyList()
  }

  private async getCompanyList() {
    this.companyList = await this.companyClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true
        },
        order: ['createdAt']
      }
    })
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.name.like = `%${this.listQuery.filter.where.name.like}%`
    t.filter.where.mobile_phone_number.like = `%${this.listQuery.filter.where.mobile_phone_number.like}%`
    if (_.isNil(t.filter.where.companyId) || _.isEqual(t.filter.where.companyId, '')) {
      delete t.filter.where.companyId
    }
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val:number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val:number) {
    super.handleCurrentChange(val)
  }

  protected async handleRecharge() {
    this.rechargeFormVisible = true
    setTimeout(() => {
      if (this.$refs['companyRecharge']) {
        const companyRecharge = this.$refs['companyRecharge'] as CompanyRecharge
        companyRecharge.reset()
      }
    }, 500)
  }

  protected async handleUpdate(row: any) {
    super.handleUpdate(row)
  }

  protected async handleLeave(row: any) {
    try {
      const r = await this.$confirm(`此操作会将司机：${row.name}置于离职状态，并回收车队资金, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      })
      if (r === 'confirm') {
        const driverClient = this.client as DriverClient
        await driverClient.leave(row.id)
        await this.getList()
        this.dialogFormVisible = false
        this.$notify({
          title: '成功',
          message: '离职成功',
          type: 'success',
          duration: 2000
        })
      } else {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      }
    } catch (e) {
      this.$message({
        type: 'info',
        message: e
      })
    }
  }

  protected async saveData() {
    super.saveData()
  }
  protected async recharge() {
    const companyRecharge = this.$refs['companyRecharge'] as CompanyRecharge
    if (await companyRecharge.recharge()) {
      this.rechargeFormVisible = false
      this.getList()
    }
  }
}
